import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-square-fill",
  templateUrl: "./med-icon-square-fill.component.html",
})
export class MedIconSquareFillComponent extends SvgMixinComponent {}
